/**
 * Client access config — add/remove clients here.
 * Each key is the Access Code (case-insensitive on login).
 * password: login password
 * company:  pre-fills company name in the app
 * period:   financial period label
 */
const CLIENTS = {
  "VERTEX2026": {
    password: "Vertex@123",
    company:  "Vertex Trading LLC",
    period:   "Year Ended 31 December 2025",
  },
  "SUNTECH2026": {
    password: "Suntech@123",
    company:  "Suntech Business Solutions",
    period:   "Year Ended 31 December 2025",
  },
  "DEMO2026": {
    password: "Demo@123",
    company:  "Demo Company",
    period:   "Year Ended 31 December 2025",
  },
};

export default CLIENTS;
